import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import preset from './default-preset/preset';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

Vue.use(Vuetify);

const sq = {
  badge: 'Distinktiv',
  close: 'Mbyll',
  dataIterator: {
    noResultsText: 'Nuk u gjet asnjë rezultat',
    loadingText: 'Duke u ngarkuar...',
  },
  dataTable: {
    itemsPerPageText: 'Rreshta për faqe:',
    ariaLabel: {
      sortDescending: 'Renditur zbritëse.',
      sortAscending: 'Renditur ngjitëse.',
      sortNone: 'Pa renditje.',
      activateNone: 'Aktivizo për të hequr renditjen.',
      activateDescending: 'Aktivizo për renditje zbritëse.',
      activateAscending: 'Aktivizo për renditje ngjitëse.',
    },
    sortBy: 'Rendit sipas',
  },
  dataFooter: {
    itemsPerPageText: 'Artikuj për faqe:',
    itemsPerPageAll: 'Të gjithë',
    nextPage: 'Faqja tjetër',
    prevPage: 'Faqja e mëparshme',
    firstPage: 'Faqja e parë',
    lastPage: 'Faqja e fundit',
    pageText: '{0}-{1} nga {2}',
  },
  noDataText: 'Nuk ka të dhëna',
  carousel: { prev: 'Pamja e mëparshme', next: 'Pamja tjetër' },
  calendar: { moreEvents: '{0} më shumë' },
  fileInput: { counter: '{0} fajlla', counterSize: '{0} fajlla ({1} gjithsej)' },
  timePicker: { am: 'AM', pm: 'PM' },
};

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    locales: { sq },
    current: (localStorage.getItem('locale') || 'sq') === 'sq' ? 'sq' : 'en',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
});
